import { Home as HomeModule } from "../modules/Home/Home";

const Home = () => {
  return <HomeModule />;
};

export default Home;
